/** Joins class names, skipping falsy values. */
export const cx = (...names: unknown[]): string => names.filter((n): n is string => typeof n === 'string' && n !== '').join(' ');
